import type { Room } from '@/data/rooms'
import type { AvailabilityResult, SearchState } from '../api/types'

function todayISO(): string {
  return new Date().toISOString().slice(0, 10)
}

function tomorrowISO(): string {
  const d = new Date()
  d.setDate(d.getDate() + 1)
  return d.toISOString().slice(0, 10)
}

export function bookingStateForRoom(
  room: Room,
  searchOverride?: SearchState | null,
  availability?: AvailabilityResult | null,
): { room: AvailabilityResult; search: SearchState } | null {
  if (!room.room_type_id) return null

  const search: SearchState = searchOverride ?? {
    check_in: todayISO(),
    check_out: tomorrowISO(),
    adults: 2,
    children: 0,
  }

  const staticImages = room.images.map((image, index) => ({ id: index, image }))

  if (availability) {
    // The backend availability response sometimes carries no public images
    // (when no RoomTypeImage rows have been uploaded for this type). Fall
    // back to the static curated photos so the booking summary still shows
    // a representative image of the room.
    const images =
      availability.images && availability.images.length > 0
        ? availability.images
        : staticImages
    return { room: { ...availability, images }, search }
  }

  const synthesized: AvailabilityResult = {
    room_type_id: room.room_type_id,
    name: room.backend_name ?? '',
    short_description: room.backend_description,
    base_price: String(room.price),
    max_occupancy: room.capacity,
    amenities: room.amenities,
    images: staticImages,
    estimated_total: String(room.price),
    estimated_nightly_rate: String(room.price),
    available_rooms_count: 1,
  }

  return { room: synthesized, search }
}
